import React from 'react';
import './LoadingText.css';

function LoadingText() {
  return <div className="loading-text">Loading</div>;
}

export default LoadingText;
